<template>
  <div v-if="signingTabs && signingTabs.length > 0">
    <ul>
      <li v-for="(configuredField, index) in signingTabs.filter(signingTab => signingTab.active)" :key="`cf-${configuredField.role}-${configuredField.fieldType}-${configuredField.sequence}-${index}`" class="configured-field">
        <div class="f-wrapper" v-if="!configuredField.edit" @click="editSignField(index)">
          <span v-if="configuredField.role === 'caregiver' || configuredField.role === 'observer' || configuredField.role === 'witness'" class="order-number">{{ configuredField.roleOrder }}</span>
          <span :style="{ 'background-color': roleColorCode[configuredField.role] }" class="color-indicator"></span>
          <span class="sign-label">{{ `${configuredField.fieldName} ${configuredField.sequence}` }}</span>
        </div>
        <div class="edit-box" v-else-if="editSignObj">
          <div class="heading-info-container" v-if="configuredField.role === 'observer' || configuredField.role === 'witness' || configuredField.role === 'caregiver'">
            <p class="mb-0 role-text text-dark d-inline text-capitalize">
              {{ configuredField.role }}
            </p>
            <span v-if="configuredField.role === 'observer' || configuredField.role === 'witness'" class="label-msg ml-4" v-b-popover.hover.top="getInfo(configuredField.role)">
              <i class="fa fa-info-circle help_icon cursor_pointer" aria-hidden="true" tabindex="0" data-html="true"></i>
            </span>
          </div>
          <CustomSelect class="mb-8" v-if="configuredField.role === 'caregiver' || configuredField.role === 'observer' || configuredField.role === 'witness'" :options="order" :selectedOption="editSignObj" :has-icon="false" selectedFilterKey="label" selectedFilterValue="roleOrder" @input="emitSelectedOrder($event)" />
          <div class="heading-info-container">
            <p class="mb-0 role-text text-dark d-inline text-capitalize">
              Type
            </p>
          </div>
          <CustomSelect :options="fieldsOptions" :selectedOption="editSignObj" @input="signTypeInputHandler" />
          <div v-if="editSignObj.fieldType == 'text' || editSignObj.fieldType == 'checkbox'" class="form-group checkbox-label">
            <label>Label</label>
            <span class="label-msg" v-b-popover.hover.top="'Provide a label for this action to provide clarity as to what this action is intended for.'">
              <i class="fa fa-info-circle help_icon cursor_pointer" aria-hidden="true" tabindex="0" data-html="true"></i>
            </span>
            <textarea v-model="editSignObj.fieldLabel" class="form-control" :placeholder="`Enter label for ${editSignObj.fieldType}`"></textarea>
          </div>
          <div v-if="editSignObj.fieldType == 'text' || editSignObj.fieldType == 'checkbox'" class="form-group checkbox-label">
            <label>Instructions</label>
            <span class="label-msg" v-b-popover.hover.top="'Provide instructions for the intended person of this action. The text entered here is for instructional purposes only and will not be visible on the final version of the document.'">
              <i class="fa fa-info-circle help_icon cursor_pointer" aria-hidden="true" tabindex="0" data-html="true"></i>
            </span>
            <textarea v-model="editSignObj.fieldInstruction" class="form-control" :placeholder="`Enter instructions for ${editSignObj.fieldType}`"></textarea>
          </div>
          <label class="required-checkbox">
            <input :value="editSignObj.required" type="checkbox" v-model="editSignObj.required" />
            <span>
              <div class="r-txt">Required</div>
            </span>
          </label>

          <div class="btn-wrapper">
            <b-button variant="secondary" size="sm" @click="cancelSignField">Cancel</b-button>
            <b-button variant="primary" size="sm" @click="updateSignField">Save</b-button>
            <span class="fa fa-trash" @click="deleteSignTab" />
          </div>
        </div>
      </li>
    </ul>
  </div>
</template>

<script>
import CustomSelect from "@/components/configure-document/custom-select";
import _ from "lodash";

export default {
  name: "configuredFields",
  props: {
    signingTabs: {
      type: Array,
      required: true
    },
    roleColorCode: {
      type: Array,
      required: true
    }
  },
  components: {
    CustomSelect
  },
  watch: {
    signingTabs: {
      handler(updatedList) {
        //find the field that has edit true in that to show the edit box
        this.setEditObject(updatedList);
      },
      deep: true
    }
  },
  data() {
    return {
      fieldsOptions: [
        {
          type: "signature",
          label: "Signature",
          icon: "static/img/signature-icon.svg"
        },
        {
          type: "initials",
          label: "Initials",
          icon: "static/img/initials-icon.svg"
        },
        {
          type: "name",
          label: "Name",
          icon: "static/img/name-icon.svg"
        },
        {
          type: "checkbox",
          label: "Checkbox",
          icon: "static/img/checkbox-icon.svg"
        },
        {
          type: "text",
          label: "Text",
          icon: "static/img/text-icon.svg"
        }
      ],
      order: [
        {
          type: "number",
          label: 1,
          fieldType: "order"
        },
        {
          type: "number",
          label: 2,
          fieldType: "order"
        }
      ],
      editSignObj: null,
      editSignObjIndex: null
    };
  },
  methods: {
    emitSelectedOrder(e) {
      this.editSignObj.roleOrder = e.label;
    },
    getInfo(role) {
      return role === "observer" ? "Observer signs in-app with participant/parent/caregiver." : "Witness signs on-site with the site team.";
    },
    editSignField(signObjIndex) {
      //If the user is already in the middle of editing any sign field then dont't allow other sign field edit.
      if (this.editSignObj) {
        this.$toastr.error("Please save the changes.");
        return;
      }
      this.$emit("editSignHere", signObjIndex);
    },
    signTypeInputHandler(signField) {
      this.editSignObj.fieldType = signField.type;
      this.editSignObj.fieldName = signField.label;
    },
    setEditObject(signingTabs) {
      //find the field that has edit true in that to show the edit box
      const editSignFieldIndex = _.findIndex(signingTabs, "edit");
      if (editSignFieldIndex >= 0) {
        this.editSignObjIndex = editSignFieldIndex;
        this.editSignObj = _.cloneDeep(signingTabs[editSignFieldIndex]);
      }
    },
    cancelSignField() {
      // this function used to reset values after click on cancel button
      this.$emit("updateSignFieldConfig", this.editSignObjIndex, this.editSignObj, true);
      this.editSignObjIndex = null;
      this.editSignObj = null;
    },
    updateSignField() {
      //Emit event to update the signingTabs prop coming from the parent component.
      this.$emit("updateSignFieldConfig", this.editSignObjIndex, this.editSignObj);
      this.editSignObjIndex = null;
      this.editSignObj = null;
    },
    deleteSignTab() {
      this.$swal({
        title: "Are you sure you want to delete this field?",
        type: "warning",
        showCancelButton: true,
        confirmButtonColor: "#b8c7ce",
        cancelButtonColor: "#34537d",
        confirmButtonText: "Cancel",
        cancelButtonText: "Yes"
      }).then(({ dismiss }) => {
        if (dismiss === "cancel") {
          this.$emit("deleteSignFieldConfig", this.editSignObjIndex);
          this.editSignObjIndex = null;
          this.editSignObj = null;
        }
      });
    }
  },
  mounted() {
    //find the field that has edit true in that to show the edit box
    this.setEditObject(this.signingTabs);
  }
};
</script>

<style lang="scss" scoped>
.order-number {
  position: absolute;
  left: 11px;
  top: 8px;
  font-size: 10px;
  color: black;
}
.fa-info-circle {
  color: #959fa4;
}

ul {
  list-style-type: none;
  margin: 0;
  padding: 0;
  display: flex;
  flex-direction: column-reverse;

  li {
    font-size: 12px;
    font-weight: bold;
    line-height: 1.33;
    color: #1e8fe1;
    &:first-of-type {
      border-bottom: solid 1px #d3dee3 !important;
    }
    &.configured-field {
      border: solid 1px #d3dee3;
      border-bottom: 0;
      background-color: rgba(228, 232, 235, 0.5);
      position: relative;

      .f-wrapper {
        padding: 5px 6px;

        &:after {
          position: absolute;
          content: "";
          top: 10px;
          right: 10px;
          width: 0;
          height: 0;
          border: 5px solid transparent;
          border-color: #4a4a4a transparent transparent transparent;
        }

        &:hover {
          background-color: rgba(228, 232, 235, 0.5);
          cursor: pointer;
        }

        .sign-label {
          display: inline-block;
          vertical-align: middle;
        }

        .color-indicator {
          width: 15px;
          height: 15px;
          border: 1px solid #c4c4c4;
          display: inline-block;
          border-radius: 25px;
          margin-right: 8px;
          vertical-align: middle;
        }
      }
    }

    .edit-box {
      padding: 19px;

      .btn-wrapper {
        text-align: right;
        margin-top: 5px;
        width: 100%;
        border: none;
        button {
          &.btn-secondary {
            font-family: "Roboto-Regular";
            font-size: 12px;
            color: #4a4a4a;
            border: solid 1px #d3dee3;
            background-color: rgba(228, 232, 235, 0.5);
            text-align: left;
            padding: 1px 15px;
          }
          &.btn-primary {
            border-radius: 2px;
            border: solid 1px #508ee1;
            background-color: #508ee1;
            font-size: 12px;
            font-family: Roboto-bold;
            padding: 1px 15px;
            margin-left: 7px;
          }
        }

        .fa-trash {
          color: #959fa4;
          padding: 5px 6px;
          opacity: 0.99;
          background: rgba(221, 230, 233, 1);
          vertical-align: middle;
          font-size: 13px;
          margin-left: 7px;

          &:hover {
            cursor: pointer;
          }
        }
      }

      .required-checkbox {
        margin-top: 17px;

        &:hover {
          cursor: pointer;
        }

        .r-txt {
          display: inline-block;
          vertical-align: middle;
          font-family: Roboto-Medium;
        }

        /*checkbox data*/
        input[type="checkbox"] + span {
          display: inline-block;
          color: #4a4a4a;
          font-weight: normal;
        }

        input[type="checkbox"] {
          display: none;
          height: 16px;
          width: 16px;
        }

        input[type="checkbox"] + span:before {
          content: "\f00c";
          border: 0.1em solid #d3dfe4;
          border-radius: 2px;
          padding: 3px 3px;
          vertical-align: middle;
          color: transparent;
          background-color: #fff;
          font: normal normal normal 10px/1 FontAwesome;
          margin-right: 10px;
          vertical-align: middle;
        }

        input[type="checkbox"]:checked + span:before {
          background-color: #1e8fe1;
          border: 0.1em solid #1e8fe1;
          color: #fff;
          font-size: 10px;
        }
      }

      .checkbox-label {
        margin-top: 10px;
        margin-bottom: 0;
        .label-msg {
          width: 11.7px;
          height: 11.7px;
          opacity: 0.7;
          margin-left: 3.2px;
          color: #959fa4;
        }
        textarea {
          border-radius: 3px;
          border: solid 1px #d3dfe4;
        }

        // for making placeholder change color
        textarea::-webkit-input-placeholder {
          color: #b0bac9 !important;
          font-size: 12px !important;
        }

        textarea:-moz-placeholder {
          /* Firefox 18- */
          color: #b0bac9 !important;
          font-size: 12px !important;
        }

        textarea::-moz-placeholder {
          /* Firefox 19+ */
          color: #b0bac9 !important;
          font-size: 12px !important;
        }

        textarea:-ms-input-placeholder {
          color: #b0bac9 !important;
          font-size: 12px !important;
        }

        textarea::placeholder {
          color: #b0bac9 !important;
          font-size: 12px !important;
        }

        label {
          margin-bottom: 1px;
          font-weight: normal;
          color: #4a4a4a;
          font-family: Roboto-Medium;
        }
      }
    }
  }
}
</style>
